import { render, staticRenderFns } from "./purchaseRequisition.vue?vue&type=template&id=1155b27e&scoped=true"
import script from "./purchaseRequisition.vue?vue&type=script&lang=js"
export * from "./purchaseRequisition.vue?vue&type=script&lang=js"
import style0 from "./purchaseRequisition.vue?vue&type=style&index=0&id=1155b27e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1155b27e",
  null
  
)

export default component.exports